<template>
    <div>
        <!-- 管理表格 通用 -->
        <el-table class="form" :data="tableData" :scrollbar-always-on="true" :sticky="true" border
            @selection-change="handleSelect" max-height="500" :header-cell-style="headerStyle">
            <!-- 选择框 -->
            <el-table-column align="center" type="selection" width="55" :selectable="selectable" />
            <!-- 表格数据列 根据数据类型带表头排序-->
            <el-table-column align="center" v-for="(item, index) in tableList" :key="index" :label="item.label" :prop="item.prop"
                :sortable="item.sortable">
                <template #default="scope">
                    <el-tag size="medium" v-if="item.type === 'label'"> {{ scope.row[item.prop] }}</el-tag>
                    <el-tag size="medium" v-else-if="item.type === 'select'"> {{ scope.row[item.prop] }}</el-tag>
                    <!-- 映射表类型 tag值需要单独映射 -->
                    <el-tag size="medium" v-else-if="item.type === 'mapping'"> {{ getMap(scope.row[item.prop]) }}</el-tag>
                    <div v-else>{{ scope.row[item.prop] }}</div>
                </template>
            </el-table-column>
            <!-- 操作栏 -->
            <el-table-column align="center" label="操作" width="220">
                <template #default="scope">
                    <el-button id="tableEdit" link type='text' @click="handleEdit(scope.row)">编辑</el-button>
                    <el-button id="tableEdit" link type='text' @click="handleCopy(scope.row)">复制</el-button>
                </template>
            </el-table-column>
        </el-table>
        <!-- 分页组件 -->
        <page-button :total="total" :page-size="pageSize" :current-page="currentPage" @page-change="handlePageChange" @sizeChange="sizeChange"/>
    </div>
</template>

<script>
import PageButton from '@/components/buttons/PageButton.vue'
export default {
  name: 'ProtocolTable',
  components: {
    PageButton
  },
  emits: ['select', 'edit', 'pagechange', 'sizeChange', 'copy'],
  props: {
    // 表格数据
    tableData: {
      type: Array,
      default: () => []
    },
    // 表头列表
    tableList: {
      type: Array,
      default: () => []
    },
    // 总条数
    total: {
      type: Number,
      default: 0
    },
    // 每页显示条数
    pageSize: {
      type: Number,
      default: 10
    },
    // 当前页码
    page: {
      type: Number,
      default: 1
    },
    // 映射列表
    mappingList: {
      type: Array,
      default: () => []
    },
    // 当前页码
    currentPage: {
      type: Number,
      default: 1
    }
  },
  data () {
    return {
      searchList: []
    }
  },
  mounted () {
    // 字典下拉框赋值
    this.$assignDictOptions(this.searchList, { protocolType: 'protocol_type' }, this.selectDictionary)
    this.$assignDictOptions(this.searchList, { deviceType: 'product_type' }, this.selectDictionary)
  },
  computed: {
    selectDictionary () {
      return this.$store.getters.getDictionaryList
    }
  },
  methods: {
    headerStyle({ row, column, rowIndex, columnIndex }) {
      // 或者返回对象形式
      return {
        'background-color': '#fafafa',
        'color': '#333',
        'font-weight': 'bold',
        'padding': '0',
      }
    },
    // 选择逻辑函数
    selectable (row, index) {
      // 根据row中的showItem字段决定是否可选
      // 也可以根据其他条件，如index、row的其他属性等
      const routeName = this.$route.name
      if (routeName === 'FormManageView') {
        return row.protocolName === '/'
      }
      if (routeName === 'ProtocolManageView') {
        return true
      }
      // 如果未来还有其他路由需要处理，可以在这里添加, 默认情况下，如果没有匹配的路由，返回true
      return true
    },
    // 选择表格行
    handleSelect (selection) {
      this.$emit('select', selection)
    },
    // 点击操作栏编辑按键
    handleEdit (row) {
      this.$emit('edit', row)
    },
    handleCopy (row) {
      this.$emit('copy', row)
    },
    // 页码改变时触发
    handlePageChange (val) {
      this.$emit('pagechange', val)
    },
    // 页码大小改变
    sizeChange (val) {
      this.$emit('sizeChange', val)
    },
    // 获取映射类型的映射值
    getMap (val) {
      const map = this.mappingList.find(item => item.value === val)
      return map ? map.label : ''
    }
  }
}
</script>

<style scoped>
  /deep/ .el-tag {
    background-color: #cbefec73;
    color: #00D8C3;
    border: 1px solid #00d8c38a;
  }
</style>
